import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { PrivacyPolicySettingsComponent } from '../privacy-policy-settings/privacy-policy-settings.component';
import { PrivacyPolicyService } from '@app/core/privacy-policy/services/privacy-policy.service';
import { IUserPrivacySettings } from '@app/core/user/store/reducers/user.reducers';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { DataLayerService } from '@app/analytics/services/data-layer.service';

@Component({
  selector: 'vc-privacy-policy-banner',
  templateUrl: './privacy-policy-banner.component.html',
  styleUrls: ['./privacy-policy-banner.component.scss']
})
export class PrivacyPolicyBannerComponent implements OnChanges, OnInit {
  @Input() privacySettings: IUserPrivacySettings;
  showBanner = false;

  private consentDoneDataLayerPayload = {
    event: 'consent_done',
    cookie_analytics: 'default_true'
  };

  constructor(
    public dialog: MatDialog,
    private platformService: PlatformService,
    private privacyPolicyService: PrivacyPolicyService,
    private dataLayerService: DataLayerService
  ) {}

  ngOnInit() {
    if (this.platformService.isBrowser) {
      this.showBanner = this.privacySettings.showBanner;

      if (!this.showBanner) {
        this.pushConsentToDataLayer(this.privacySettings);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.platformService.isBrowser) {
      if (changes.privacySettings) {
        this.showBanner = changes.privacySettings.currentValue.showBanner;
      }
    }
  }

  acceptAll() {
    const settings: IUserPrivacySettings = {
      showBanner: false,
      acceptCookies: 'selected_true',
      acceptRetargeting: 'selected_true',
      acceptAnalytics: 'selected_true'
    };

    this.privacyPolicyService.updateSettings(settings);

    this.pushConsentToDataLayer(settings);
  }

  showPrivacyOptionsPopin() {
    this.dialog
      .open(PrivacyPolicySettingsComponent, {
        disableClose: false,
        maxWidth: 600,
        data: this.privacySettings
      })
      .afterClosed()
      .subscribe(
        (settings: IUserPrivacySettings) => {
          if (settings) {
            this.pushConsentToDataLayer(settings);
          }
        },
        () => null
      );
  }

  private pushConsentToDataLayer(settings: IUserPrivacySettings) {
    this.dataLayerService.pushGA({
      ...this.consentDoneDataLayerPayload,
      cookie_analytics: settings.acceptAnalytics === 'selected_true' ? 'default_true' : 'default_false'
    });
  }
}
